import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RetiradaPedidosClienteProvider,
  useRetiradaPedidosCliente,
} from "./context/RetiradaPedidosClienteContext";
import { RankingStatusPedidosView } from "./components/RetiradaPedidosClienteView";
import { useAuth } from "../../../context/AuthContext";
import { hasFullAccessUser } from "../../../lib/screenAccess";

const RetiradasPedidosClienteContent: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdministrador = hasFullAccessUser(user);
  const {
    emPreparo,
    prontos,
    lojas,
    isLoading,
    selectedLojaId,
    lojaSelectorVisible,
    selectedLojaNome,
    toggleLojaPicker,
    selectAllLojas,
    selectLoja,
  } = useRetiradaPedidosCliente();

  if (isLoading) {
    return (
      <div className="relative flex min-h-screen items-center justify-center overflow-auto bg-gradient-to-br from-primary via-red-900 to-primary text-white">
        <div className="text-center">
          <p className="text-xl">Carregando retirada no balcão...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingStatusPedidosView
      emPreparo={emPreparo}
      prontos={prontos}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={lojaSelectorVisible}
      showLojaSelectorUI={isAdministrador}
      selectedLojaNome={selectedLojaNome}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaPicker}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
    />
  );
};

const RetiradaPedidosClientePage: React.FC = () => {
  return (
    <RetiradaPedidosClienteProvider>
      <RetiradasPedidosClienteContent />
    </RetiradaPedidosClienteProvider>
  );
};

export default RetiradaPedidosClientePage;
